import React from "react";
import { useNavigate } from "react-router-dom";
import {
    Create,
    GetAllCandidates,
    GetAllPositions,
} from "adminApi/CandidateShortlistApi/CandidateShortlist";
import { validateForm } from "utils/validation";
import { CandidateShortlistRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddCandidateShortlistForm from "./components/AddCandidateShortlistForm";
import fields from "../json/CandidateShortlist.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";

const AddCandidateShortlist = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce(
        (acc, field) => ({ ...acc, [field.name]: "" }),
        {}
    );

    // Form state
    const { values, errors, handleChange, setErrors } = useFormChange(
        initialValues,
        CandidateShortlistRules
    );

    // Dropdown options
    const { data: CandidateOptions = [] } = useFetchAllData(GetAllCandidates);
    const { data: PositionOptions = [] } = useFetchAllData(GetAllPositions);

    // Form submit
    const { loading, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) =>
                formData.append(key, val ?? "")
            );
            return await Create({ data: formData });
        },
        (vals) => {
            const err = validateForm(vals, CandidateShortlistRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Candidate shortlisted successfully"
    );

    return (
        <>
            {loading && <Spinner isSpinner={true} />}
            <AddCandidateShortlistForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loading}
                title="Add Candidate Shortlist"
                CandidateOptions={CandidateOptions}
                PositionOptions={PositionOptions}
            />
        </>
    );
};

export default AddCandidateShortlist;
